import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { I18nService } from '@localize/services';
import { FeedbackService, FeedbackStyle, FeedbackTitle } from '@services/feedback';

import { IAppKey } from '../../../../../../services/appkey';
import { DialogService } from '../../../../../../services/dialog';
import { AppKeyTableActions } from '../appkey-table/appkey-table.models';
import { EditAppKey } from './appkey-edit.models';

@Component({
	selector: 'app-appkey-edit',
	templateUrl: './appkey-edit.dialog.html',
	styleUrls: ['./appkey-edit.dialog.scss']
})
export class AppKeyEditDialogComponent implements OnInit {
	private dialogRefClose: () => void;

	public unsavedChanges = false;
	public appKeyTableActions = AppKeyTableActions;

	constructor(
		private i18nService: I18nService,
		private feedbackService: FeedbackService,
		@Inject(MAT_DIALOG_DATA) public dialogData: EditAppKey,
		private dialogRef: MatDialogRef<AppKeyEditDialogComponent>,
		private router: Router,
		private dialogService: DialogService
	) {
		// Store original close function and replace with unsaved version, remember to restore on use
		this.dialogRefClose = this.dialogService.interceptClose(this.dialogRef, this, this.closeDialog);
	}

	public ngOnInit(): void {
	}

	public closeDialog(callback: () => void = this.handleEvent): void {
		if (this.unsavedChanges) {
			this.feedbackService.confirm({
				title: FeedbackTitle.warning,
				message: this.i18nService.get(
					'You have unsaved changes that will be lost. Are you sure you want to continue?',
					'app.prompt.pending-changes-confirm-message'
				),
				style: FeedbackStyle.error,
				callback: (confirmed: boolean) => {
					if (confirmed) callback();
				}
			});
		} else {
			callback();
		}
	}

	public openAction(action: AppKeyTableActions): void {
		this.closeDialog(() => this.handleEvent(null, action));
	}

	public navigate(url: string, queryParams = {}): void {
		this.closeDialog(() => {
			this.handleEvent();
			this.router.navigate([url], { queryParams });
		});
	}

	public handleEvent = (appKey: IAppKey = null, action: AppKeyTableActions = null): void => {
		this.dialogRefClose();

		if (this.dialogData.callback) this.dialogData.callback(action, appKey);
	};
}
